import { Row } from "antd";
import { Route, Switch } from "react-router-dom";
import SendMail from "./SendMail/SendMail";
import AdminAnalyse from "./Analyse/Analyse";
import BookingSeasons from "./BookingSeasons/BookingSeasons";
import CreateOrEditBookingSeason from "./BookingSeasons/CreateOrEditBookingSeason";
import TakeAttendanceForEvent from "./TakeAttendanceForEvent/TakeAttendanceForEvent";

const AdminTools = () => {
  return (
    <Row gutter={[0, 48]}>
      <Switch>
        <Route path="/admin/tools/send-email/" component={SendMail} />
        <Route path="/admin/tools/analyse/" component={AdminAnalyse} />
        <Route exact path="/admin/tools/booking-seasons/" component={BookingSeasons} />
        <Route path="/admin/tools/booking-seasons/new/" component={CreateOrEditBookingSeason} />
        <Route path="/admin/tools/booking-seasons/edit/:id/" component={CreateOrEditBookingSeason} />
        <Route exact path="/admin/tools/take-attendance-for-event/" component={TakeAttendanceForEvent} />
        <Route path="/admin/tools/take-attendance-for-event/:id/" component={TakeAttendanceForEvent} />
      </Switch>
    </Row>
  );
};

export default AdminTools;
